import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loader } from '../../../../common/elements/index';
import * as commonActions from '../../../../../actions/common/index';
import * as profileActions from '../../profile/actions';
import JobPreferencesForm from './elements/JobPreferencesForm';
import {extractValue} from '../../../../../helpers/formFieldHelpers';
import {browserHistory} from 'react-router';
import { updateNotification } from '../../../../../actions/common/site_notifications'; 

class JobPreferences extends Component  {

    state = {
        isValidationError: false,
    }

    componentDidMount () {
        const { 
            countries, 
            getCountries, 
            getProfile, 
            expertise, 
            getExpertise, 
            industries, 
            getIndustries, 
            markets, 
            getMarkets, 
            sectors, 
            getSectors } = this.props;

        const personId = localStorage.getItem( 'person_id' );

        getProfile( personId );

        if (!countries || !expertise || !industries || !markets || !sectors ) {
            getCountries();
            getExpertise();
            getIndustries();
            getMarkets();
            getSectors();
        }
    }

    getPropNames = ( array, collection ) => array.map(ele => this.props[`${ collection }`].find(e => e.id === ele) );

    getRegionData = ( countryId, array) => {
        const regionsList = this.props.profile.locations.countries.find( country => country.id === countryId.value ).regions;
        return array.map(ele => {
                    const obj = regionsList.find( e => e.id === ele );
                    if(obj !== undefined) {
                        obj.country_id = countryId.label;
                        return obj;
                    }
                } );
    };

    handleFormSubmit ( form ) {

        const { profile, createExpertise } = this.props, expertiseIds = {}, dataWithNames = {}, { personId } = profile.name;

        const data = { personId: personId, notificationId: 1, completed: 1 }; 
        this.props.updateNotification( data );

        const isValidationError = (form.country_id && form.country_id.value && form.location_id.length && form.preferred_location.length && form.preferred_industry.length && form.industry_id.length && form.market_id.length && form.sector_id.length && form.expertise_id.length ) ? 
        true : false;
        isValidationError && this.setState({ isValidationError: true  });

        expertiseIds.industry_id = extractValue( form.industry_id );
        expertiseIds.sector_id = extractValue( form.sector_id );
        expertiseIds.market_id = extractValue( form.market_id );
        expertiseIds.expertise_id = extractValue( form.expertise_id );
        expertiseIds.preferred_industry = extractValue( form.preferred_industry );
        expertiseIds.preferred_location = extractValue( form.preferred_location );
        expertiseIds.location_id =  extractValue(form.location_id)

        dataWithNames.expertise = this.getPropNames( expertiseIds.expertise_id, "expertise");
        dataWithNames.sectors = this.getPropNames( expertiseIds.sector_id, "sectors");
        dataWithNames.markets = this.getPropNames( expertiseIds.market_id, "markets");
        dataWithNames.industries = this.getPropNames( expertiseIds.industry_id, "industries");
        dataWithNames.preferred_industry = this.getPropNames( expertiseIds.preferred_industry, "industries");
        dataWithNames.preferred_location = this.getRegionData( form.country_id, expertiseIds.preferred_location);
        dataWithNames.location_id = this.getRegionData( form.country_id, expertiseIds.location_id)
        dataWithNames.location_id = dataWithNames.location_id.filter(el => {
            return el != null;
        })

        createExpertise( personId, expertiseIds, dataWithNames );
    }

    handleCancel () {
        browserHistory.push ( '/' );
    }

    render () {

        const { 
            expertise, 
            industries,
            markets, 
            sectors, 
            profile } = this.props;

        if (  !expertise || !industries || !markets || !sectors || !profile.locations.countries  ) {
            return <Loader />;
        }

        if ( typeof profile.ui.isFetching  === 'undefined' || profile.ui.isFetching ) return  <Loader />;
        const message = "set your job alert and member search preferences:";
        return (
            <JobPreferencesForm
                profile={ profile }
                countriesList={ profile.locations.countries }
                expertiseList={ expertise }
                industriesList={ industries }
                marketsList={ markets }
                sectorsList={ sectors }
                handleFormSubmit={ ( form ) => this.handleFormSubmit( form ) }
                handleCancel={ () => this.handleCancel () }
                history={ history }
                message={ message }
                clearJobLocations={this.props.clearJobLocations}
            />
        )
    }
}

JobPreferences.propTypes = {
    profile: PropTypes.object,
    countries: PropTypes.array,
    industries: PropTypes.array,
    markets: PropTypes.array,
    sectors: PropTypes.array,
    clearJobLocations: PropTypes.func,
    getCountries: PropTypes.func,
    getExpertise: PropTypes.func,
    getIndustries: PropTypes.func,
    getMarkets: PropTypes.func,
    getSectors: PropTypes.func,
    getProfile: PropTypes.func,
    createExpertise: PropTypes.func
}

const mapStateToProps = ( state ) => {
    return {
        profile: state.profile,
        countries: state.countries.countries,
        expertise: state.expertise.expertise,
        industries: state.industries.industries,
        markets: state.markets.markets,
        sectors: state.sectors.sectors,
    }
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        getCountries: () => dispatch( commonActions.countries.getCountries() ),
        getExpertise: () => dispatch ( commonActions.expertise.getExpertise() ),
        getIndustries: () => dispatch( commonActions.industries.getIndustries() ),
        getMarkets: () => dispatch( commonActions.markets.getMarkets() ),
        getSectors: () => dispatch( commonActions.sectors.getSectors() ),
        clearJobLocations: () => dispatch( commonActions.countries.clearJobLocations() ),
        getProfile: ( personId ) => dispatch( profileActions.getProfile( personId ) ),
        createExpertise: ( personId, expertise, dataWithNames ) => dispatch( profileActions.createExpertise( personId, expertise, dataWithNames ) ),
        updateNotification: ( data ) => dispatch( updateNotification( data ) )
    }
};

export default connect( mapStateToProps, mapDispatchToProps )( JobPreferences );


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/JobPreferences.js